<template>
  <div
    class="news-cont-box"
    ref="box">
    <div>
        <p style="text-indent:32px;">亲爱的大美开滦用户朋友：为进一步提升用户体验，我们对平台进行了维护更新。您可到华为、应用宝、ios等应用商店下载更新，也可复制下方对应网址到浏览器中打开或扫描对应二维码进行下载更新。如不更新将会对您的用户体验造成一定影响，感谢您的使用和支持！</p>
        <p>华为应用商店：</p>
        <p>https://url.cloud.huawei.com/hBHjGH8QMw</p>
         <img src="../assets/img/dmkl/huawei.png" alt=""/>
        <p>应用宝商店：</p>
        <p>https://a.app.qq.com/o/simple.jsp?pkgname=com.zgynet.dmkl</p>
        <img src="../assets/img/dmkl/yingyong.png" alt=""/>
        <p>IOS应用商店：</p>
        <p>https://apps.apple.com/cn/app/%E5%A4%A7%E7%BE%8E%E5%BC%80%E6%BB%A6/id1495357589</p>
         <img src="../assets/img/dmkl/ios.png" alt=""/>
        <p>平台二维码下载：</p>
      </div>
    <!-- <div
      v-if="wmkUse"
      style="text-align:center;margin-bottom:16PX;padding:0 30PX;padding-top:16PX;border-top:1PX solid #f3f3f3"
      :style="{fontSize:waterMark.wmkWordSize+'PX',opacity:(waterMark.wmkWordTrans/100)}">
      {{waterMark.wmkWordContent}}
    </div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped>

.news-cont-box {
  padding: 0 16PX;
  box-sizing: border-box;
  overflow: hidden;
}
.news-cont-box{
  font-size: 18PX;
  margin-bottom: 16PX;
  margin-top: 22PX;
  color: #0D141E;
  line-height: 2;
  word-wrap: break-word;
  font-family: SourceHan;
  text-align: justify;
  overflow-y: auto;
  padding-right: 15PX;
}
.news-cont-box p{
  margin: 0 0 16PX 0;
  min-height: 18PX;
}

.news-cont-box img {
  display: block;
  margin: 5PX auto;
  max-width: 100%;
  object-fit: scale-down;
}

.news-cont-box video {
  width: 100%;
  height: 200PX;
  display: block;
  margin: 0 auto;
  max-width: 100%;
  background-color: #000;
}
.news-cont-box h1 {
  font-size: 32PX; 
}
.news-cont-box h3 {
  font-size: 19PX;
  margin-bottom: 16PX; 
}
.news-cont-box h3 > p {
  margin-bottom: 16PX; 
}
.news-cont-box h1,
.news-cont-box h3 {
  color: #0D141E;
  font-weight: bold; 
}
.news-cont-box strong {
  font-weight: bold; 
}
.news-cont-box a {
  color: #153D9A;
  font-weight: bold;
  text-decoration: none;
  border-bottom: 1PX solid #153D9A; 
}
.news-cont-box hr {
  margin: 40PX 20PX; 
}
</style>
